import React from "react";
import styled from "styled-components";

const BlankSpace = () => {
  return <BlankSpaceContainer></BlankSpaceContainer>;
};

// styled components
const BlankSpaceContainer = styled.div`
  width: 100vw;
  height: 5rem;
`;

export default BlankSpace;
